import { makeAutoObservable } from "mobx";
import { v4 as uuidv4 } from "uuid";

export class Instruction {
  id = uuidv4();
  text = "";

  constructor(text?: string) {
    makeAutoObservable(this);
    this.text = text ?? "";
  }

  // Setters
  setText = (value: string): void => {
    this.text = value;
  };

  // Methods
  reset = (): void => {
    this.id = uuidv4();
    this.text = "";
  };
}
